"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLE = void 0;
var DEFAULT_STYLE = {
  ANIMATION_DURATION: '1s',
  WIDTH: '50px',
  HEIGHT: '50px',
  STROKE_WIDTH: '2'
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;